/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { usePlaceOrderMutation } from "../../services/orderApi";
import Select from "react-select";
import Swal from 'sweetalert2';
import { MdEdit } from "react-icons/md";
import { FaLightbulb } from "react-icons/fa";

const API = "https://backend.hira-tech.co.uk";
// Apne router ke hisaab se ye path adjust karein
const DRAFTS_PATH = "/admin/drafts";

const ProductForm = ({
  id,
  number,
  onRemove,
  product,
  onProductChange,
  productOptions = []
}) => {
  const formattedOptions = productOptions.map((p) => ({
    value: p.product_Id,
    label: `${p.product_Name} (${p.SKU})`,
    price: p.product_Price
  }));

  let selectedOption = formattedOptions.find(
    (opt) => opt.value === parseInt(product.productId)
  );

  if (!selectedOption && product.productId && product.productLabel) {
    selectedOption = {
      value: parseInt(product.productId),
      label: product.productLabel,
    };
  }

  const handleProductChange = (selected) => {
    if (selected) {
      const selectedProduct = productOptions.find(p => p.product_Id === selected.value);
      onProductChange(id, {
        productId: selected.value,
        productLabel: selected.label,
        customPrice: selectedProduct ? selectedProduct.product_Price : ""
      });
    } else {
      onProductChange(id, {
        productId: "",
        productLabel: "",
        customPrice: ""
      });
    }
  };

  const handlePriceChange = (e) => {
    onProductChange(id, { customPrice: e.target.value });
  };

  return (
    <div className="product-form-container">
      <div className="form-group">
        <label className="form-label">Product:</label>
        <Select
          options={formattedOptions}
          value={selectedOption || null}
          onChange={handleProductChange}
          placeholder="Search product by SKU or name..."
          isSearchable
          styles={{
            control: (provided) => ({
              ...provided,
              border: "1px solid #ccc",
              borderRadius: "6px",
              padding: "2px",
              boxShadow: "none",
            }),
            option: (provided, state) => ({
              ...provided,
              backgroundColor: state.isFocused ? "#004aad" : "white",
              color: state.isFocused ? "white" : "black",
            }),
          }}
        />
      </div>
      <div className="form-group">
        <label className="form-label">Quantity:</label>
        <input
          type="number"
          className="form-input"
          placeholder="1"
          value={product.quantity || 1}
          onChange={(e) => onProductChange(id, { quantity: e.target.value })}
          min="1"
        />
      </div>
      <div className="form-group">
        <label className="form-label">Product Price:</label>
        <input
          type="number"
          className="form-input"
          placeholder="Enter Product price"
          value={product.customPrice || ""}
          onChange={handlePriceChange}
          step="0.01"
        />
        {selectedOption && (
          <small className="price-note">
            Default price: R.s {selectedOption.price || "N/A"}
          </small>
        )}
      </div>
      {number > 1 && (
        <button
          className="close-button"
          onClick={() => onRemove(id)}
          title="Remove"
        >
          ×
        </button>
      )}
    </div>
  );
};

const SearchableSelectWithManualInput = ({
  label,
  options,
  value,
  onChange,
  placeholder = "Search or select...",
  required = false,
  className = "",
  optionLabelKey = "name",
  optionValueKey = "id",
  getOptionLabel = null
}) => {
  const [isManualMode, setIsManualMode] = useState(false);
  const [manualValue, setManualValue] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const inputRef = useRef(null);

  const isCustomValue = value && !options.some(opt => String(opt[optionValueKey]) === String(value));

  useEffect(() => {
    if (isCustomValue && value) {
      setManualValue(value);
      setIsManualMode(true);
    } else if (!isCustomValue && value) {
      const selectedOption = options.find(opt => String(opt[optionValueKey]) === String(value));
      if (selectedOption) {
        const label = getOptionLabel ? getOptionLabel(selectedOption) : selectedOption[optionLabelKey];
        setManualValue(label);
        setSearchTerm(label);
      }
      setIsManualMode(false);
    } else {
      setManualValue("");
      setSearchTerm("");
      setIsManualMode(false);
    }
  }, [value, options, optionLabelKey, optionValueKey, isCustomValue, getOptionLabel]);

  const getFilteredOptions = () => {
    if (!searchTerm.trim()) return options;
    const searchLower = searchTerm.toLowerCase().trim();
    return options.filter(opt => {
      const label = getOptionLabel ? getOptionLabel(opt) : opt[optionLabelKey];
      return label.toLowerCase().includes(searchLower);
    });
  };

  const filteredOptions = getFilteredOptions();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    setIsDropdownOpen(true);
    setManualValue(value);

    const matchedOption = options.find(opt => {
      const label = getOptionLabel ? getOptionLabel(opt) : opt[optionLabelKey];
      return label.toLowerCase() === value.toLowerCase().trim();
    });

    if (matchedOption && value.trim() !== "") {
      onChange(String(matchedOption[optionValueKey]), false);
      setIsManualMode(false);
    } else if (value.trim() === "") {
      onChange("", false);
      setIsManualMode(false);
    } else {
      onChange(value, true);
      setIsManualMode(true);
    }
  };

  const handleOptionSelect = (option) => {
    const selectedValue = String(option[optionValueKey]);
    const label = getOptionLabel ? getOptionLabel(option) : option[optionLabelKey];
    setSearchTerm(label);
    setManualValue(label);
    setIsDropdownOpen(false);
    setIsManualMode(false);
    onChange(selectedValue, false);
  };

  const handleInputFocus = () => {
    setIsDropdownOpen(true);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && searchTerm.trim() !== "") {
      const exactMatch = options.find(opt => {
        const label = getOptionLabel ? getOptionLabel(opt) : opt[optionLabelKey];
        return label.toLowerCase() === searchTerm.toLowerCase().trim();
      });
      if (exactMatch) {
        handleOptionSelect(exactMatch);
      } else {
        onChange(searchTerm.trim(), true);
        setIsManualMode(true);
        setIsDropdownOpen(false);
      }
    }
    if (e.key === "Escape") {
      setIsDropdownOpen(false);
    }
  };

  return (
    <div className={`form-group ${className}`} ref={dropdownRef}>
      <label className="form-label">{label}:</label>
      <div style={{ position: 'relative' }}>
        <input
          ref={inputRef}
          type="text"
          className="form-input"
          value={searchTerm}
          onChange={handleInputChange}
          onFocus={handleInputFocus}
          onKeyDown={handleKeyDown}
          placeholder={placeholder}
          style={{
            paddingRight: '40px',
            cursor: 'text'
          }}
          autoComplete="off"
        />
        <button
          type="button"
          onClick={() => {
            if (isDropdownOpen) {
              setIsDropdownOpen(false);
            } else {
              setIsDropdownOpen(true);
              inputRef.current?.focus();
            }
          }}
          style={{
            position: 'absolute',
            right: '8px',
            top: '50%',
            transform: 'translateY(-50%)',
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            fontSize: '16px',
            color: '#666',
            padding: '4px 8px'
          }}
        >
          ▼
        </button>

        {isDropdownOpen && filteredOptions.length > 0 && (
          <div
            style={{
              position: 'absolute',
              top: '100%',
              left: 0,
              right: 0,
              backgroundColor: 'white',
              border: '1px solid #ccc',
              borderRadius: '4px',
              maxHeight: '200px',
              overflowY: 'auto',
              zIndex: 1000,
              marginTop: '2px',
              boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
            }}
          >
            {filteredOptions.map((option) => {
              const label = getOptionLabel ? getOptionLabel(option) : option[optionLabelKey];
              return (
                <div
                  key={option[optionValueKey]}
                  onClick={() => handleOptionSelect(option)}
                  style={{
                    padding: '8px 12px',
                    cursor: 'pointer',
                    borderBottom: '1px solid #eee',
                    fontSize: '14px',
                    transition: 'background 0.2s'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#004aad';
                    e.target.style.color = 'white';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = 'transparent';
                    e.target.style.color = 'inherit';
                  }}
                >
                  {label}
                </div>
              );
            })}
          </div>
        )}

        {isDropdownOpen && filteredOptions.length === 0 && searchTerm.trim() !== "" && (
          <div
            style={{
              position: 'absolute',
              top: '100%',
              left: 0,
              right: 0,
              backgroundColor: 'white',
              border: '1px solid #ccc',
              borderRadius: '4px',
              padding: '8px 12px',
              zIndex: 1000,
              marginTop: '2px',
              color: '#666',
              fontSize: '14px',
              boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
            }}
          >
            No matching options found. Press Enter to use "{searchTerm}" as custom value.
          </div>
        )}

        {isManualMode && value && (
          <div
            style={{
              marginTop: '4px',
              fontSize: '12px',
              color: '#004aad',
              fontStyle: 'italic'
            }}
          >
            <MdEdit />Custom value: {value}
          </div>
        )}
      </div>
    </div>
  );
};

const OrderedProducts = ({
  productOptions,
  products,
  setProducts,
  dropdown1, setDropdown1,
  dropdown2, setDropdown2,
  dropdown3, setDropdown3,
  dropdown4, setDropdown4,
  dropdown5, setDropdown5,
  types = [],
  categories = [],
  variations = [],
  implantCompanies = [],
  brands = [],
  filteredProducts = [],
  showNoProductsAlert = false,
  onResetFilters
}) => {
  const addProduct = () => {
    setProducts([...products, {
      id: Date.now(),
      productId: "",
      quantity: 1,
      customPrice: "",
      productLabel: "",
    }]);
  };

  const removeProduct = (id) => {
    if (products.length > 1) {
      setProducts(products.filter((p) => p.id !== id));
    }
  };

  const updateProduct = (id, changes) => {
    setProducts(products.map(product =>
      product.id === id ? { ...product, ...changes } : product
    ));
  };

  const availableProducts = filteredProducts.length > 0 ? filteredProducts : productOptions;

  return (
    <div className="products-main-container">
      <div className="payment-title-container">
        <span className="payment-title-main">Add ordered_product</span>
        <button
          type="button"
          className="reset-filters-button"
          onClick={onResetFilters}
        >
          Reset Filters
        </button>
      </div>
      <div className="dropdowns-wrapper">
        <SearchableSelectWithManualInput
          label="Type"
          options={types}
          value={dropdown1}
          onChange={(value, isCustom) => setDropdown1(value)}
          placeholder="Search or type type..."
          optionLabelKey="type_name"
          optionValueKey="type_id"
        />
        <SearchableSelectWithManualInput
          label="Category"
          options={categories}
          value={dropdown2}
          onChange={(value, isCustom) => setDropdown2(value)}
          placeholder="Search or type category..."
          optionLabelKey="category_Name"
          optionValueKey="catrgort_id"
        />
        <SearchableSelectWithManualInput
          label="Variation"
          options={variations}
          value={dropdown3}
          onChange={(value, isCustom) => setDropdown3(value)}
          placeholder="Search or type variation..."
          optionLabelKey="variation_name"
          optionValueKey="variation_id"
        />
        <SearchableSelectWithManualInput
          label="Implant Company"
          options={implantCompanies}
          value={dropdown4}
          onChange={(value, isCustom) => setDropdown4(value)}
          placeholder="Search or type company..."
          optionLabelKey="company_name"
          optionValueKey="company_id"
        />
        <SearchableSelectWithManualInput
          label="Implant Connection"
          options={brands}
          value={dropdown5}
          onChange={(value, isCustom) => setDropdown5(value)}
          placeholder="Search or type connection..."
          optionLabelKey={(brand) => `${brand.brand_name} (${brand.implant_company?.company_name || 'N/A'})`}
          optionValueKey="brand_id"
          getOptionLabel={(brand) => `${brand.brand_name} (${brand.implant_company?.company_name || 'N/A'})`}
        />
      </div>

      {showNoProductsAlert && (
        <div className="no-products-alert">
          No products found matching your filters. Showing all products instead. Please adjust your filters.
        </div>
      )}

      <div className="products-container">
        {products.map((product, index) => (
          <div key={product.id} className="product-card-wrapper">
            <ProductForm
              id={product.id}
              number={index + 1}
              onRemove={removeProduct}
              product={product}
              onProductChange={updateProduct}
              productOptions={availableProducts}
            />
          </div>
        ))}
      </div>
      <button type="button" className="add-payment-button" onClick={addProduct}>
        <span className="plus-icon">+</span>
        <span className="button-text">Add another product</span>
      </button>
    </div>
  );
};

const PlaceOrders = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const [trackingId, setTrackingId] = useState("");
  const [status, setStatus] = useState("Order Placed");
  const today = new Date().toISOString().split("T")[0];
  const [placementDate, setPlacementDate] = useState(today);
  const [deliveryDate, setDeliveryDate] = useState(today);
  const [deliveryRange, setDeliveryRange] = useState("2PM - 4PM");
  const [customer, setCustomer] = useState("");
  const [address, setAddress] = useState("");
  const [addressManual, setAddressManual] = useState("");
  const [isAddressManualMode, setIsAddressManualMode] = useState(false);
  const [products, setProducts] = useState([{
    id: Date.now(),
    productId: "",
    quantity: 1,
    customPrice: "",
    productLabel: "",
  }]);
  const [productOptions, setProductOptions] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [addresses, setAddresses] = useState([]);
  const [deliveryCharges, setDeliveryCharges] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [note, setNote] = useState("");
  const [discount, setDiscount] = useState(0);
  const [subtotal, setSubtotal] = useState(0);
  const [customerReference, setCustomerReference] = useState("");
  const [deliveryMethod, setDeliveryMethod] = useState("Same day delivery");
  const [courierService, setCourierService] = useState("DHL");
  const [agentName, setAgentName] = useState("Muddsar Rashid");
  const [agentNumber, setAgentNumber] = useState("+923005562457");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [placeOrder, { isLoading, error }] = usePlaceOrderMutation();
  const [dropdown1, setDropdown1] = useState("");
  const [dropdown2, setDropdown2] = useState("");
  const [dropdown3, setDropdown3] = useState("");
  const [dropdown4, setDropdown4] = useState("");
  const [dropdown5, setDropdown5] = useState("");
  const [types, setTypes] = useState([]);
  const [categories, setCategories] = useState([]);
  const [variations, setVariations] = useState([]);
  const [implantCompanies, setImplantCompanies] = useState([]);
  const [brands, setBrands] = useState([]);
  const [showNoProductsAlert, setShowNoProductsAlert] = useState(false);
  const [latestTrackingId, setLatestTrackingId] = useState("");
  const [isAddressLoading, setIsAddressLoading] = useState(false);
  const [isCourierManualMode, setIsCourierManualMode] = useState(false);
  const [manualCourierService, setManualCourierService] = useState("");
  const [prevNote, setPrevNote] = useState(""); // Store previous note to detect changes

  // ---- Customer reference duplicate check ----
  const [existingReferences, setExistingReferences] = useState([]);
  const [showRefSuggestions, setShowRefSuggestions] = useState(false);

  // ---- Draft (backend) ----
  const [draftId, setDraftId] = useState("");
  const [draftSavedAt, setDraftSavedAt] = useState("");
  const [isDraftSaving, setIsDraftSaving] = useState(false);
  const [draftError, setDraftError] = useState(false);
  const draftIdRef = useRef("");
  const savingRef = useRef(false);
  const pendingSaveRef = useRef(false);
  const submittingRef = useRef(false);
  const skipSaveRef = useRef(false);
  const latestDraftRef = useRef({ hasData: false, title: "", data: {} });

  const noteRef = useRef(null);

  // Predefined courier services
  const courierOptions = [
    "DHL",
    "TCS",
    "Leopards",
    "Daewoo (Kalma Chowk)",
    "Daewoo (Faisalabad)",
    "Daewoo (Thokar)",
    "Daewoo (Multan)",
    "Bykea"
  ];

  const courierNoteMap = {
    "DHL": "Order will be shipped via DHL courier service.",
    "TCS": "Order will be shipped via TCS courier service.",
    "Leopards": "Order will be shipped via Leopards courier service.",
    "Daewoo (Kalma Chowk)": "Order will be sent via Daewoo (Kalma Chowk).",
    "Daewoo (Faisalabad)": "Order will be sent via Daewoo (Faisalabad).",
    "Daewoo (Thokar)": "Order will be sent via Daewoo (Thokar).",
    "Daewoo (Multan)": "Order will be sent via Daewoo (Multan).",
    "Bykea": "Order will be delivered via Bykea courier service."
  };

  const getNoteFromCourier = (courier) => {
    return courierNoteMap[courier] || `Order will be shipped via ${courier} courier service.`;
  };

  // Helper function to check if courier is predefined
  const isPredefinedCourier = (courier) => {
    return courierOptions.includes(courier);
  };

  // Remove all courier notes from text
  const removeCourierNotesFromText = (text) => {
    if (!text) return "";
    let cleanedText = text;
    courierOptions.forEach(courier => {
      const noteText = courierNoteMap[courier];
      if (noteText && cleanedText.includes(noteText)) {
        cleanedText = cleanedText.replace(noteText, "");
      }
    });
    const manualNotePattern = /Order will be shipped via .* courier service\./g;
    cleanedText = cleanedText.replace(manualNotePattern, "");
    cleanedText = cleanedText.replace(/\n{2,}/g, "\n").trim();
    return cleanedText;
  };

  const handleCourierChange = (e) => {
    const selectedValue = e.target.value;
    if (isPredefinedCourier(selectedValue)) {
      setCourierService(selectedValue);
      setIsCourierManualMode(false);
      setManualCourierService("");
      const autoNote = getNoteFromCourier(selectedValue);
      if (selectedValue) {
        const cleanedNote = removeCourierNotesFromText(note);
        const newNote = cleanedNote ? cleanedNote + "\n" + autoNote : autoNote;
        setNote(newNote);
      }
    } else {
      setCourierService(selectedValue);
      setIsCourierManualMode(true);
      setManualCourierService(selectedValue);
      if (selectedValue.trim()) {
        const autoNote = getNoteFromCourier(selectedValue);
        const cleanedNote = removeCourierNotesFromText(note);
        const newNote = cleanedNote ? cleanedNote + "\n" + autoNote : autoNote;
        setNote(newNote);
      }
    }
  };

  const handleManualCourierChange = (e) => {
    const value = e.target.value;
    setManualCourierService(value);
    setCourierService(value);
    setIsCourierManualMode(true);
  };

  const handleManualCourierBlur = () => {
    const value = manualCourierService.trim();
    if (value) {
      const autoNote = getNoteFromCourier(value);
      const cleanedNote = removeCourierNotesFromText(note);
      const newNote = cleanedNote ? cleanedNote + "\n" + autoNote : autoNote;
      setNote(newNote);
    }
  };

  const handleManualCourierKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      const value = manualCourierService.trim();
      if (value) {
        const autoNote = getNoteFromCourier(value);
        const cleanedNote = removeCourierNotesFromText(note);
        const newNote = cleanedNote ? cleanedNote + "\n" + autoNote : autoNote;
        setNote(newNote);
      }
      e.target.blur();
    }
  };

  const toggleCourierMode = () => {
    if (isCourierManualMode) {
      setIsCourierManualMode(false);
      setCourierService("DHL");
      setManualCourierService("");
      const autoNote = getNoteFromCourier("DHL");
      const cleanedNote = removeCourierNotesFromText(note);
      const newNote = cleanedNote ? cleanedNote + "\n" + autoNote : autoNote;
      setNote(newNote);
    } else {
      setIsCourierManualMode(true);
      setManualCourierService(courierService);
    }
  };

  const resetFilters = () => {
    setDropdown1("");
    setDropdown2("");
    setDropdown3("");
    setDropdown4("");
    setDropdown5("");
  };

  // =====================================================
  // CUSTOMER REFERENCE HELPERS
  // =====================================================
  const normalizeRef = (v) => (v || "").trim().toLowerCase();
  const trimmedRef = customerReference.trim();

  const isRefTaken =
    trimmedRef !== "" &&
    existingReferences.some((r) => normalizeRef(r) === normalizeRef(trimmedRef));

  const matchingExisting = trimmedRef
    ? existingReferences
        .filter((r) => normalizeRef(r).includes(normalizeRef(trimmedRef)))
        .slice(0, 5)
    : [];

  const uniqueSuggestions = (() => {
    if (!isRefTaken) return [];
    const taken = new Set(existingReferences.map(normalizeRef));
    const result = [];
    for (let n = 2; result.length < 3 && n < 100; n++) {
      const candidate = `${trimmedRef}-${n}`;
      if (!taken.has(normalizeRef(candidate))) result.push(candidate);
    }
    const dated = `${trimmedRef}-${today.replace(/-/g, "")}`;
    if (!taken.has(normalizeRef(dated))) result.push(dated);
    return result;
  })();

  // =====================================================
  // DRAFT (BACKEND) FUNCTIONS
  // =====================================================
  const buildDraftData = () => ({
    status, placementDate, deliveryDate, deliveryRange, customer, phoneNumber,
    address, addressManual, isAddressManualMode, products, deliveryCharges,
    discount, customerReference, deliveryMethod, courierService,
    isCourierManualMode, manualCourierService, agentName, agentNumber, note,
    dropdown1, dropdown2, dropdown3, dropdown4, dropdown5
  });

  const hasDraftData = () =>
    customer || phoneNumber || address || addressManual || customerReference ||
    note || products.some((p) => p.productId) ||
    parseFloat(deliveryCharges) > 0 || parseFloat(discount) > 0;

  const getDraftTitle = () => {
    const c = customers.find((c) => String(c.id) === String(customer));
    if (c) return `${c.first_Name} ${c.last_Name}`.trim();
    return customerReference.trim() || "Untitled draft";
  };

  // Har render par latest form values ref me rakhte hain (unmount / page close par bhi save ho sake)
  latestDraftRef.current = {
    hasData: !!hasDraftData(),
    title: getDraftTitle(),
    data: buildDraftData()
  };

  const saveDraft = async (keepalive = false) => {
    if (submittingRef.current) return false;
    const { hasData, title, data } = latestDraftRef.current;
    if (!hasData) return false;

    // Pehli save chal rahi ho to is change ko queue kar do (lose na ho)
    if (savingRef.current) {
      pendingSaveRef.current = true;
      return false;
    }

    savingRef.current = true;
    setIsDraftSaving(true);
    let ok = false;
    try {
      const isUpdate = !!draftIdRef.current;
      const url = isUpdate
        ? `${API}/order/drafts/${draftIdRef.current}/`
        : `${API}/order/drafts/`;
      const res = await fetch(url, {
        method: isUpdate ? "PUT" : "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ title, data }),
        keepalive
      });
      if (!res.ok) throw new Error(`Draft save failed (${res.status})`);
      const saved = await res.json();
      draftIdRef.current = saved.draft_id;
      setDraftId(saved.draft_id);
      setDraftError(false);
      setDraftSavedAt(
        new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
      );
      ok = true;
    } catch (e) {
      console.error("Draft save error:", e);
      setDraftError(true);
    } finally {
      savingRef.current = false;
      setIsDraftSaving(false);
    }

    // Save ke dauran jo changes aaye unhe foran dobara save karo
    if (pendingSaveRef.current) {
      pendingSaveRef.current = false;
      if (!submittingRef.current) return saveDraft(keepalive);
    }
    return ok;
  };

  const deleteDraftFromServer = async () => {
    pendingSaveRef.current = false;
    while (savingRef.current) {
      await new Promise((r) => setTimeout(r, 100));
    }
    const id = draftIdRef.current;
    if (!id) return;
    try {
      await fetch(`${API}/order/drafts/${id}/`, { method: "DELETE" });
    } catch (e) {
      console.error("Draft delete error:", e);
    }
    draftIdRef.current = "";
    setDraftId("");
    setDraftSavedAt("");
  };

  const applyDraft = (d) => {
    skipSaveRef.current = true;
    setStatus(d.status ?? "Order Placed");
    setPlacementDate(d.placementDate ?? today);
    setDeliveryDate(d.deliveryDate ?? today);
    setDeliveryRange(d.deliveryRange ?? "2PM - 4PM");
    setCustomer(d.customer ?? "");
    setPhoneNumber(d.phoneNumber ?? "");
    setAddress(d.address ?? "");
    setAddressManual(d.addressManual ?? "");
    setIsAddressManualMode(!!d.isAddressManualMode);
    if (Array.isArray(d.products) && d.products.length) setProducts(d.products);
    setDeliveryCharges(d.deliveryCharges ?? 0);
    setDiscount(d.discount ?? 0);
    setCustomerReference(d.customerReference ?? "");
    setDeliveryMethod(d.deliveryMethod ?? "Same day delivery");
    setCourierService(d.courierService ?? "DHL");
    setIsCourierManualMode(!!d.isCourierManualMode);
    setManualCourierService(d.manualCourierService ?? "");
    setAgentName(d.agentName ?? "Muddsar Rashid");
    setAgentNumber(d.agentNumber ?? "+923005562457");
    setNote(d.note ?? "");
    setDropdown1(d.dropdown1 ?? "");
    setDropdown2(d.dropdown2 ?? "");
    setDropdown3(d.dropdown3 ?? "");
    setDropdown4(d.dropdown4 ?? "");
    setDropdown5(d.dropdown5 ?? "");
  };

  useEffect(() => {
    const id = searchParams.get("draft");
    if (!id) return;

    const loadDraft = async () => {
      try {
        const res = await fetch(`${API}/order/drafts/${id}/`);
        if (!res.ok) throw new Error("Draft not found");
        const draft = await res.json();
        draftIdRef.current = draft.draft_id;
        setDraftId(draft.draft_id);
        applyDraft(draft.data || {});
        Swal.fire({
          toast: true, position: "top-end", icon: "info",
          title: "Draft loaded", showConfirmButton: false, timer: 1800
        });
      } catch (e) {
        console.error("Draft load error:", e);
        Swal.fire({
          icon: "error", title: "Draft not found",
          text: "This draft could not be loaded. It may have been deleted.",
          confirmButtonColor: "#004aad"
        });
        setSearchParams({}, { replace: true });
      }
    };
    loadDraft();
  }, []);

  // Kuch bhi type karte hi (1 sec ruk kar) draft khud save ho jata hai
  useEffect(() => {
    if (skipSaveRef.current) {
      skipSaveRef.current = false;
      return;
    }
    const timer = setTimeout(() => { saveDraft(); }, 1000);
    return () => clearTimeout(timer);
  }, [status, placementDate, deliveryDate, deliveryRange, customer, phoneNumber,
      address, addressManual, isAddressManualMode, products, deliveryCharges,
      discount, customerReference, deliveryMethod, courierService,
      isCourierManualMode, manualCourierService, agentName, agentNumber, note,
      dropdown1, dropdown2, dropdown3, dropdown4, dropdown5]);

  // Page chhorte waqt (sidebar click / tab close) bhi draft save ho
  useEffect(() => {
    const onUnload = () => { saveDraft(true); };
    window.addEventListener("beforeunload", onUnload);
    return () => {
      window.removeEventListener("beforeunload", onUnload);
      saveDraft(true);
    };
  }, []);

  const handleDraftClick = async () => {
    await saveDraft();
    while (savingRef.current) {
      await new Promise((r) => setTimeout(r, 100));
    }
    navigate(DRAFTS_PATH);
  };

  // =====================================================
  // DATA FETCHING
  // =====================================================
  useEffect(() => {
    const fetchLatestTrackingId = async () => {
      try {
        const response = await fetch(`${API}/order/getAllorder/`);
        if (!response.ok) throw new Error("Failed to fetch orders");
        const data = await response.json();

        setExistingReferences(
          data
            .map((o) => o.customer_Reference)
            .filter((r) => r && typeof r === "string")
        );

        if (data.length > 0) {
          const trackingIds = data
            .map(order => order.order_Tracking_Id)
            .filter(id => id && typeof id === 'string')
            .map(id => {
              const match = id.match(/(\d+)$/);
              return match ? parseInt(match[1]) : 0;
            });

          const maxId = Math.max(...trackingIds, 0);
          const newTrackingId = `HT${String(maxId + 1).padStart(5, '0')}`;
          setLatestTrackingId(newTrackingId);
          setTrackingId(newTrackingId);
        } else {
          const initialTrackingId = "";
          setLatestTrackingId(initialTrackingId);
          setTrackingId(initialTrackingId);
        }
      } catch (error) {
        console.error("Error fetching latest tracking ID:", error);
        const fallbackTrackingId = "";
        setLatestTrackingId(fallbackTrackingId);
        setTrackingId(fallbackTrackingId);
      }
    };

    fetchLatestTrackingId();
  }, []);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await fetch(`${API}/product/getAllproduct/`);
        if (!res.ok) throw new Error("Failed to fetch products");
        const data = await res.json();
        setProductOptions(data);
        setFilteredProducts(data);
      } catch (err) {
        console.error("Product fetch error:", err);
      }
    };
    fetchProducts();
  }, []);

  useEffect(() => {
    let filtered = [...productOptions];

    if (dropdown1) {
      const isCustom = !types.some(t => String(t.type_id) === String(dropdown1));
      if (!isCustom) {
        filtered = filtered.filter(
          (p) => p.type?.type_id === parseInt(dropdown1)
        );
      }
    }

    if (dropdown2) {
      const isCustom = !categories.some(c => String(c.catrgort_id) === String(dropdown2));
      if (!isCustom) {
        filtered = filtered.filter(
          (p) => p.product_category?.catrgort_id === parseInt(dropdown2)
        );
      }
    }

    if (dropdown3) {
      const isCustom = !variations.some(v => String(v.variation_id) === String(dropdown3));
      if (!isCustom) {
        filtered = filtered.filter(
          (p) => p.product_variation?.variation_id === parseInt(dropdown3)
        );
      }
    }

    if (dropdown4) {
      const isCustom = !implantCompanies.some(c => String(c.company_id) === String(dropdown4));
      if (!isCustom) {
        filtered = filtered.filter(
          (p) => p.implant_company?.company_id === parseInt(dropdown4)
        );
      }
    }

    if (dropdown5) {
      const isCustom = !brands.some(b => String(b.brand_id) === String(dropdown5));
      if (!isCustom) {
        filtered = filtered.filter(
          (p) => p.product_brand?.brand_id === parseInt(dropdown5)
        );
      }
    }

    setFilteredProducts(filtered);

    const hasActiveFilters = dropdown1 || dropdown2 || dropdown3 || dropdown4 || dropdown5;
    setShowNoProductsAlert(hasActiveFilters && filtered.length === 0);
  }, [
    productOptions,
    dropdown1,
    dropdown2,
    dropdown3,
    dropdown4,
    dropdown5,
    types,
    categories,
    variations,
    implantCompanies,
    brands
  ]);

  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const response = await fetch(`${API}/user/getAllcustomers/`);
        if (!response.ok) throw new Error("Failed to fetch customers");
        const data = await response.json();
        setCustomers(data);
      } catch (error) {
        console.error("Error fetching customers:", error);
      }
    };
    fetchCustomers();
  }, []);

  useEffect(() => {
    const fetchTypes = async () => {
      try {
        const response = await fetch(`${API}/product/api/type/`);
        if (!response.ok) {
          throw new Error("Failed to fetch types");
        }
        const data = await response.json();
        setTypes(data);
      } catch (error) {
        console.error("Error fetching types:", error);
      }
    };
    fetchTypes();
  }, []);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetch(`${API}/product/api/categories/`);
        if (!response.ok) {
          throw new Error("Failed to fetch categories");
        }
        const data = await response.json();
        setCategories(data);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };
    fetchCategories();
  }, []);

  useEffect(() => {
    const fetchVariations = async () => {
      try {
        const response = await fetch(`${API}/product/api/variation/`);
        if (!response.ok) {
          throw new Error("Failed to fetch variations");
        }
        const data = await response.json();
        setVariations(data);
      } catch (error) {
        console.error("Error fetching variations:", error);
      }
    };
    fetchVariations();
  }, []);

  useEffect(() => {
    const fetchImplantCompanies = async () => {
      try {
        const response = await fetch(`${API}/product/api/implant-companies/`);
        if (!response.ok) {
          throw new Error("Failed to fetch implant companies");
        }
        const data = await response.json();
        setImplantCompanies(data);
      } catch (error) {
        console.error("Error fetching implant companies:", error);
      }
    };
    fetchImplantCompanies();
  }, []);

  useEffect(() => {
    const fetchBrands = async () => {
      try {
        const response = await fetch(`${API}/product/api/brands/`);
        if (!response.ok) {
          throw new Error("Failed to fetch brands");
        }
        const data = await response.json();
        setBrands(data);
      } catch (error) {
        console.error("Error fetching brands:", error);
      }
    };
    fetchBrands();
  }, []);

  useEffect(() => {
    const fetchAddresses = async () => {
      setIsAddressLoading(true);
      try {
        const response = await fetch(`${API}/order/addresses/`);
        if (!response.ok) throw new Error("Failed to fetch addresses");
        const data = await response.json();

        const formattedAddresses = data.map((addr) => ({
          id: addr.address_Id,
          city: addr.city?.trim() || "",
          area: addr.area?.trim() || "",
          street: addr.street_Number?.trim() || "",
          house: addr.house_Number?.trim() || "",
          fullAddress: `${addr.house_Number || ''}${addr.house_Number ? ', ' : ''}Street ${addr.street_Number || ''}${addr.street_Number ? ', ' : ''}${addr.area || ''}${addr.area ? ', ' : ''}${addr.city || ''}`.trim()
        }));

        setAddresses(formattedAddresses);
      } catch (error) {
        console.error("Error fetching addresses:", error);
        try {
          const fallbackResponse = await fetch(`${API}/order/getAllorder/`);
          if (!fallbackResponse.ok) throw new Error("Failed to fetch orders for addresses");
          const data = await fallbackResponse.json();
          const uniqueAddresses = [];
          const seen = new Set();
          data.forEach((order) => {
            const addr = order.address;
            if (addr) {
              const key = `${addr.city}-${addr.area}-${addr.street_Number}-${addr.house_Number}`;
              if (!seen.has(key)) {
                seen.add(key);
                uniqueAddresses.push({
                  id: addr.address_Id,
                  city: addr.city?.trim() || "",
                  area: addr.area?.trim() || "",
                  street: addr.street_Number?.trim() || "",
                  house: addr.house_Number?.trim() || "",
                  fullAddress: `${addr.house_Number || ''}${addr.house_Number ? ', ' : ''}Street ${addr.street_Number || ''}${addr.street_Number ? ', ' : ''}${addr.area || ''}${addr.area ? ', ' : ''}${addr.city || ''}`.trim()
                });
              }
            }
          });
          setAddresses(uniqueAddresses);
        } catch (fallbackError) {
          console.error("Fallback address fetch also failed:", fallbackError);
          setAddresses([]);
        }
      } finally {
        setIsAddressLoading(false);
      }
    };
    fetchAddresses();
  }, []);

  const calculateSubtotal = () => {
    const productTotal = products.reduce((total, p) => {
      const price = parseFloat(p.customPrice) || 0;
      return total + (price * (parseInt(p.quantity) || 1));
    }, 0);
    const newSubtotal = productTotal + parseFloat(deliveryCharges || 0) - parseFloat(discount || 0);
    setSubtotal(newSubtotal);
    setTotalAmount(newSubtotal);
  };

  useEffect(() => {
    calculateSubtotal();
  }, [products, deliveryCharges, discount]);

  const handleAddressToggle = () => {
    setIsAddressManualMode(!isAddressManualMode);
    if (!isAddressManualMode) {
      const selectedAddress = addresses.find(a => String(a.id) === String(address));
      if (selectedAddress) {
        setAddressManual(selectedAddress.fullAddress || "");
      } else {
        setAddressManual("");
      }
      setAddress("");
    } else {
      setAddressManual("");
    }
  };

  const handleAddressSelect = (e) => {
    setAddress(e.target.value);
  };

  const handleAddressManualChange = (e) => {
    setAddressManual(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isRefTaken) {
      Swal.fire({
        icon: 'warning',
        title: 'Duplicate Customer Reference',
        text: `"${trimmedRef}" already exists. Please use a different reference.`,
        confirmButtonColor: '#004aad'
      });
      return;
    }

    let addressData = {};

    if (isAddressManualMode) {
      const addressParts = addressManual.split(',').map(part => part.trim());

      addressData = {
        house_Number: addressParts[0] || "",
        street_Number: addressParts[1] || "",
        area: addressParts[2] || "",
        city: addressParts[3] || ""
      };
    } else {
      const selectedAddress = addresses.find(a => String(a.id) === String(address));
      if (selectedAddress) {
        addressData = {
          house_Number: selectedAddress.house || "",
          street_Number: selectedAddress.street || "",
          area: selectedAddress.area || "",
          city: selectedAddress.city || ""
        };
      } else {
        addressData = {
          house_Number: "",
          street_Number: "",
          area: "",
          city: ""
        };
      }
    }

    const hasAddressData = addressData.house_Number || addressData.street_Number ||
                          addressData.area || addressData.city;

    if (!hasAddressData) {
      Swal.fire({
        icon: 'warning',
        title: 'Address Required',
        text: 'Please provide a complete address for the order.',
        confirmButtonColor: '#004aad',
        confirmButtonText: 'OK'
      });
      return;
    }

    const orderData = {
      tracking_Id: trackingId,
      customer: customer,
      phone_Number: phoneNumber,
      address: addressData,
      products: products.map(p => {
        if (p.productId) {
          return {
            product_Id: parseInt(p.productId),
            quantity: parseInt(p.quantity) || 1,
            custom_price: p.customPrice ? parseFloat(p.customPrice) : undefined
          };
        }
        return null;
      }).filter(p => p !== null),
      payment: {
        amount_Paid: subtotal,
        payment_Status: "Pending",
        payment_Type: "Monthly Statement"
      },
      order_Status: status,
      order_Placement_date: placementDate,
      order_Delivery_date: deliveryDate,
      delivery_time_range: deliveryRange,
      delivery_Charges: parseFloat(deliveryCharges) || 0,
      discount: parseFloat(discount) || 0,
      subtotal: parseFloat(subtotal) || 0,
      total_Amount: parseFloat(totalAmount) || 0,
      customer_Reference: customerReference?.trim() || undefined,
      delivery_Method: deliveryMethod,
      courier_service: courierService,
      agent_Name: agentName,
      agent_Number: agentNumber,
      note: note?.trim() || undefined,
      selected_type: dropdown1 || undefined,
      selected_category: dropdown2 || undefined,
      selected_variation: dropdown3 || undefined,
      selected_implant_company: dropdown4 || undefined,
      selected_brand: dropdown5 || undefined
    };

    if (orderData.products.length === 0) {
      Swal.fire({
        icon: 'warning',
        title: 'Products Required',
        text: 'Please add at least one product to the order.',
        confirmButtonColor: '#004aad',
        confirmButtonText: 'OK'
      });
      return;
    }

    submittingRef.current = true;

    try {
      const response = await placeOrder(orderData).unwrap();
      const selectedCustomer = customers.find(c => String(c.id) === String(customer));
      const customerName = selectedCustomer ? `${selectedCustomer.first_Name} ${selectedCustomer.last_Name}` : "Customer";

      // Order place ho gaya -> draft list se remove
      await deleteDraftFromServer();
      if (searchParams.get("draft")) setSearchParams({}, { replace: true });

      if (trimmedRef) setExistingReferences((prev) => [...prev, trimmedRef]);

      Swal.fire({
        icon: 'success',
        title: 'Congratulations!',
        text: `The order for ${customerName} has been placed successfully with Tracking ID: ${trackingId}.`,
        confirmButtonColor: '#004aad',
        confirmButtonText: 'OK'
      });

      setStatus("Order Placed");
      setPlacementDate(today);
      setDeliveryDate(today);
      setDeliveryRange("2PM - 4PM");
      setCustomer("");
      setAddress("");
      setAddressManual("");
      setIsAddressManualMode(false);
      setProducts([{ id: Date.now(), productId: "", quantity: 1, customPrice: "", productLabel: "" }]);
      setDeliveryCharges(0);
      setTotalAmount(0);
      setNote("");
      setDiscount(0);
      setSubtotal(0);
      setCustomerReference("");
      setDeliveryMethod("Same day delivery");
      setCourierService("DHL");
      setAgentName("Muddsar Rashid");
      setAgentNumber("+923005562457");
      setPhoneNumber("");
      setIsCourierManualMode(false);
      setManualCourierService("");
      resetFilters();
      setDraftError(false);
      // Reset render hone tak save band rakho, taake khali form ka draft na bane
      setTimeout(() => { submittingRef.current = false; }, 1500);
    } catch (err) {
      submittingRef.current = false;
      console.error("Order placement error:", err);

      let errorMessage = "Failed to place order. Please check all fields and try again.";
      if (err.data) {
        if (typeof err.data === 'string') {
          errorMessage = err.data;
        } else if (err.data.error) {
          errorMessage = err.data.error;
        } else if (err.data.message) {
          errorMessage = err.data.message;
        } else if (err.data.detail) {
          errorMessage = err.data.detail;
        } else {
          const firstKey = Object.keys(err.data)[0];
          if (firstKey && err.data[firstKey]) {
            errorMessage = `${firstKey}: ${err.data[firstKey]}`;
          }
        }
      }

      Swal.fire({
        icon: 'error',
        title: 'Order Failed',
        text: errorMessage,
        confirmButtonColor: '#004aad',
        confirmButtonText: 'OK'
      });
    }
  };

  const styles = `
    .order-container {
      font-family: 'Inter', sans-serif;
      padding: 24px;
      max-width: 1500px;
      margin: 0 auto;
    }
    .page-title-wrapper {
      margin-bottom: -3px;
      font-weight: bold;
    }
    .page-title {
      text-align: left;
      font-size: 22px;
      font-weight: 600;
      color: #004aad;
      margin: 0;
    }
    .page-header-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 8px;
    }
    .draft-wrapper {
      display: flex;
      align-items: center;
      gap: 10px;
    }
    .draft-status {
      font-size: 12px;
      color: #28a745;
      font-style: italic;
      font-weight: 400;
    }
    .draft-status.saving {
      color: #b27b00;
    }
    .draft-status.error {
      color: #d33;
      font-style: normal;
      font-weight: 600;
    }
    .draft-button {
      background: #fff;
      color: #004aad;
      border: 1px solid #004aad;
      padding: 6px 14px;
      border-radius: 4px;
      font-size: 13px;
      font-weight: 600;
      cursor: pointer;
    }
    .draft-button:hover {
      background: #004aad;
      color: #fff;
    }
    .form-wrapper {
      background: #f4f4f4;
      padding: 20px;
      border: 1px solid #e2e6ea;
      margin-bottom: 20px;
    }
    .form-row {
      margin-bottom: 16px;
    }
    .form-group {
      display: flex;
      flex-direction: column;
      margin-bottom: 12px;
      position: relative;
    }
    .form-group label {
      font-size: 14px;
      font-weight: 600;
      margin-bottom: 6px;
      color: #004aad;
    }
    .form-group input,
    .form-group select,
    .form-group textarea {
      padding: 10px;
      border: 1px solid #ccc;
      border-radius: 6px;
      font-size: 14px;
      outline: none;
    }
    .payment-main-container,
    .products-main-container {
      margin-top: 20px;
      margin-left: -2px;
    }
    .payment-title-container {
      background-color: transparent;
      padding: 5px 10px;
      margin-bottom: 5px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .payment-title-main {
      font-size: 18px;
      color: #004aad;
      font-weight: 600;
    }
    .reset-filters-button {
      background: #ff6b6b;
      color: white;
      border: none;
      padding: 6px 12px;
      border-radius: 4px;
      font-size: 12px;
      cursor: pointer;
    }
    .reset-filters-button:hover {
      background: #ff5252;
    }
    .products-container {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }
    .product-card-wrapper {
      background-color: #f5f5f5;
      padding: 15px;
      position: relative;
      border: 1px solid #e2e6ea;
      border-radius: 6px;
      margin-bottom: 10px;
    }
    .product-form-container {
      display: flex;
      flex-direction: column;
      gap: 15px;
    }
    .dropdowns-wrapper {
      display: flex;
      gap: 15px;
      margin-bottom: 20px;
      padding: 0 10px;
      flex-wrap: wrap;
    }
    .dropdowns-wrapper .form-group {
      flex: 1;
      min-width: 150px;
      margin-bottom: 0;
    }
    .address-wrapper {
      display: flex;
      gap: 10px;
      align-items: flex-end;
    }
    .address-wrapper .form-group {
      flex: 1;
    }
    .address-toggle-button {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 6px;
      padding: 8px 16px;
      background: #004aad;
      color: white;
      border: none;
      border-radius: 4px;
      cursor: pointer;
      font-size: 12px;
      white-space: nowrap;
      height: 40px;
      margin-bottom: 4px;
    }
    .address-toggle-button:hover {
      background: #00388c;
    }
    .address-toggle-button.manual-mode {
      background: #6c757d;
    }
    .address-toggle-button.manual-mode:hover {
      background: #5a6268;
    }
    .address-toggle-button svg {
      font-size: 16px;
    }
    .add-payment-button {
      display: flex;
      align-items: center;
      color: #fff;
      border: none;
      padding: 5px 10px;
      font-size: 14px;
      margin-top: 10px;
      cursor: pointer;
      background: #004aad;
      border-radius: 4px;
    }
    .add-payment-button:hover {
      background: #00388c;
    }
    .plus-icon {
      margin-right: 8px;
      font-size: 18px;
      font-weight: bold;
    }
    .form-label {
      font-weight: 500;
      margin-bottom: 5px;
      color: #333;
      font-size: 14px;
    }
    .form-input,
    .form-select,
    .form-textarea {
      border: 1px solid #ddd;
      border-radius: 4px;
      padding: 8px 12px;
      font-size: 14px;
      width: 100%;
      box-sizing: border-box;
      background-color: white;
    }
    .form-select {
      background-color: white;
      cursor: pointer;
    }
    textarea.form-textarea {
      resize: vertical;
      min-height: 60px;
    }
    .close-button {
      background: none;
      border: none;
      font-size: 20px;
      cursor: pointer;
      color: #999;
      position: absolute;
      top: 10px;
      right: 10px;
    }
    .close-button:hover {
      color: #004aad;
    }
    .submit-button {
      padding: 10px 15px;
      border: none;
      border-radius: 4px;
      cursor: pointer;
      font-size: 14px;
      font-weight: 500;
      background-color: #004aad;
      color: white;
      margin-top: 20px;
    }
    .submit-button:hover {
      background-color: #00388c;
    }
    .submit-button:disabled {
      background-color: #cccccc;
      cursor: not-allowed;
    }
    .no-products-alert {
      background-color: #fff3cd;
      border: 1px solid #ffeaa7;
      color: #856404;
      padding: 12px 16px;
      border-radius: 6px;
      margin: 15px 0;
      text-align: center;
      font-weight: 500;
    }
    .price-note {
      color: #666;
      font-size: 12px;
      margin-top: 4px;
      font-style: italic;
    }
    .tracking-id-note {
      color: #28a745;
      font-size: 12px;
      margin-top: 4px;
      font-style: italic;
    }
    .address-loading {
      color: #666;
      font-size: 12px;
      margin-top: 4px;
      font-style: italic;
    }
    .note-hint {
      color: #28a745;
      font-size: 12px;
      margin-top: 4px;
      font-style: italic;
    }
    .courier-toggle-button {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 6px;
      padding: 8px 16px;
      background: #004aad;
      color: white;
      border: none;
      border-radius: 4px;
      cursor: pointer;
      font-size: 12px;
      white-space: nowrap;
      height: 40px;
      margin-bottom: 4px;
    }
    .courier-toggle-button:hover {
      background: #00388c;
    }
    .courier-toggle-button.manual-mode {
      background: #6c757d;
    }
    .courier-toggle-button.manual-mode:hover {
      background: #5a6268;
    }
    .courier-toggle-button svg {
      font-size: 16px;
    }
    .courier-wrapper {
      display: flex;
      gap: 10px;
      align-items: flex-end;
    }
    .courier-wrapper .form-group {
      flex: 1;
    }
    .courier-manual-hint {
      color: #6c757d;
      font-size: 12px;
      margin-top: 4px;
      font-style: italic;
    }

    .form-group input.input-warning,
    .input-warning {
      background-color: #fff8db !important;
      border: 1px solid #f0ad00 !important;
    }
    .ref-warning-text {
      color: #b27b00;
      font-size: 12px;
      margin-top: 4px;
      font-weight: 500;
    }
    .ref-suggestions {
      position: absolute;
      bottom: 100%;
      left: 0;
      right: 0;
      z-index: 1000;
      background: #fff;
      border: 1px solid #ccc;
      border-radius: 4px;
      box-shadow: 0 -4px 8px rgba(0,0,0,0.1);
      margin-bottom: 2px;
      max-height: 220px;
      overflow-y: auto;
    }
    .ref-suggestions-title {
      font-size: 11px;
      font-weight: 600;
      padding: 6px 12px;
      background: #fff8db;
      color: #b27b00;
    }
    .ref-title-ok {
      background: #e8f5e9;
      color: #28a745;
    }
    .ref-item {
      padding: 7px 12px;
      font-size: 14px;
      border-bottom: 1px solid #eee;
    }
    .ref-item-used {
      color: #999;
      cursor: not-allowed;
    }
    .ref-item-ok {
      cursor: pointer;
    }
    .ref-item-ok:hover {
      background: #004aad;
      color: #fff;
    }
  `;

  return (
    <div>
      <style>{styles}</style>
      <div className="order-container">
        <div className="page-title-wrapper page-header-row">
          <h2 className="page-title">Add Order</h2>
          <div className="draft-wrapper">
            {isDraftSaving && <span className="draft-status saving">Saving draft...</span>}
            {!isDraftSaving && draftError && (
              <span className="draft-status error">⚠ Draft not saved (backend error)</span>
            )}
            {!isDraftSaving && !draftError && draftSavedAt && (
              <span className="draft-status">Draft saved {draftSavedAt}</span>
            )}
            <button type="button" className="draft-button" onClick={handleDraftClick}>
              📝 Drafts
            </button>
          </div>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-wrapper">
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Order Tracking Id:</label>
                <input
                  type="text"
                  className="form-input"
                  value={trackingId}
                  onChange={(e) => setTrackingId(e.target.value)}
                  placeholder="Enter tracking ID"
                />
                <small className="tracking-id-note">
                  Auto-generated: {latestTrackingId} (You can modify if needed)
                </small>
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Order Status:</label>
                <select
                  className="form-select"
                  value={status}
                  onChange={(e) => setStatus(e.target.value)}
                >
                  <option value="Order Pending">Order Pending</option>
                  <option value="Order Placed">Order Placed</option>
                  <option value="Under Package">Under Package</option>
                  <option value="On The way to deliver">On The way to deliver</option>
                  <option value="Delivered">Delivered</option>
                  <option value="Canceled">Canceled</option>
                </select>
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Order Placement Date:</label>
                <input
                  type="date"
                  className="form-input"
                  value={placementDate}
                  onChange={(e) => setPlacementDate(e.target.value)}
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Order Delivery Date:</label>
                <input
                  type="date"
                  className="form-input"
                  value={deliveryDate}
                  onChange={(e) => setDeliveryDate(e.target.value)}
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Order Delivery Time:</label>
                <input
                  type="text"
                  className="form-input"
                  value={deliveryRange}
                  onChange={(e) => setDeliveryRange(e.target.value)}
                  placeholder="e.g., 2PM - 4PM"
                />
              </div>
            </div>
          </div>
          <div className="form-wrapper">
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Customer:</label>
                <select
                  value={customer}
                  onChange={(e) => {
                    const selectedId = e.target.value;
                    setCustomer(selectedId);
                    const selectedCustomer = customers.find((c) => String(c.id) === selectedId);
                    if (selectedCustomer) {
                      setPhoneNumber(selectedCustomer.phone_Number || "");
                      if (selectedCustomer.address) {
                        const addr = addresses.find((a) => String(a.id) === String(selectedCustomer.address));
                        if (addr) {
                          setAddress(String(addr.id));
                          return;
                        }
                      }
                      if (selectedCustomer.company_address) {
                        const compAddr = addresses.find((a) => String(a.id) === String(selectedCustomer.company_address));
                        if (compAddr) {
                          setAddress(String(compAddr.id));
                          return;
                        }
                      }
                      setAddress("");
                    }
                  }}
                  className="form-select"
                  required
                >
                  <option value="">Select a customer</option>
                  {customers.map((c) => (
                    <option key={c.id} value={c.id}>
                      {c.first_Name} {c.last_Name} ({c.email})
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Phone Number:</label>
                <input
                  type="text"
                  className="form-input"
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  placeholder="Enter phone number"
                  required
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Address:</label>
                <div className="address-wrapper">
                  {!isAddressManualMode ? (
                    <>
                      <div className="form-group" style={{ flex: 1, marginBottom: 0 }}>
                        <select
                          value={address}
                          onChange={handleAddressSelect}
                          className="form-select"
                          required
                        >
                          <option value="">Select an address</option>
                          {addresses.map((a) => (
                            <option key={a.id} value={a.id}>
                              {a.fullAddress || `${a.house}, Street ${a.street}, ${a.area}, ${a.city}`}
                            </option>
                          ))}
                        </select>
                        {isAddressLoading && (
                          <small className="address-loading">Loading addresses...</small>
                        )}
                        {!isAddressLoading && addresses.length === 0 && (
                          <small className="address-loading">No addresses available. Please add an address first.</small>
                        )}
                      </div>
                      <button
                        type="button"
                        className="address-toggle-button"
                        onClick={handleAddressToggle}
                      >
                        <MdEdit /> Type manually
                      </button>
                    </>
                  ) : (
                    <>
                      <div className="form-group" style={{ flex: 1, marginBottom: 0 }}>
                        <input
                          type="text"
                          className="form-input"
                          value={addressManual}
                          onChange={handleAddressManualChange}
                          placeholder="Enter full address (House, Street, Area, City)"
                          required
                        />
                        <small style={{ color: '#666', fontSize: '11px' }}>
                          Format: House Number, Street Number, Area, City
                        </small>
                      </div>
                      <button
                        type="button"
                        className="address-toggle-button manual-mode"
                        onClick={handleAddressToggle}
                      >
                        📋 Select from list
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
          <OrderedProducts
            productOptions={productOptions}
            products={products}
            setProducts={setProducts}
            dropdown1={dropdown1}
            setDropdown1={setDropdown1}
            dropdown2={dropdown2}
            setDropdown2={setDropdown2}
            dropdown3={dropdown3}
            setDropdown3={setDropdown3}
            dropdown4={dropdown4}
            setDropdown4={setDropdown4}
            dropdown5={dropdown5}
            setDropdown5={setDropdown5}
            types={types}
            categories={categories}
            variations={variations}
            implantCompanies={implantCompanies}
            brands={brands}
            filteredProducts={filteredProducts}
            showNoProductsAlert={showNoProductsAlert}
            onResetFilters={resetFilters}
          />
          <div className="form-wrapper">
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Delivery Charges:</label>
                <input
                  type="number"
                  className="form-input"
                  value={deliveryCharges}
                  onChange={(e) => setDeliveryCharges(e.target.value)}
                  min="0"
                  step="0.01"
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Discount:</label>
                <input
                  type="number"
                  className="form-input"
                  value={discount}
                  onChange={(e) => setDiscount(e.target.value)}
                  min="0"
                  step="0.01"
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Subtotal:</label>
                <input
                  type="number"
                  className="form-input"
                  value={subtotal}
                  readOnly
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Total Amount:</label>
                <input
                  type="number"
                  className="form-input"
                  value={totalAmount}
                  readOnly
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Customer Reference:</label>

                {showRefSuggestions && (matchingExisting.length > 0 || isRefTaken) && (
                  <div className="ref-suggestions">
                    {matchingExisting.length > 0 && (
                      <>
                        <div className="ref-suggestions-title">Already in database</div>
                        {matchingExisting.map((r) => (
                          <div key={r} className="ref-item ref-item-used">{r}</div>
                        ))}
                      </>
                    )}
                    {uniqueSuggestions.length > 0 && (
                      <>
                        <div className="ref-suggestions-title ref-title-ok">Available suggestions</div>
                        {uniqueSuggestions.map((s) => (
                          <div
                            key={s}
                            className="ref-item ref-item-ok"
                            onMouseDown={(e) => {
                              e.preventDefault();
                              setCustomerReference(s);
                              setShowRefSuggestions(false);
                            }}
                          >
                            {s}
                          </div>
                        ))}
                      </>
                    )}
                  </div>
                )}

                <input
                  type="text"
                  className={`form-input ${isRefTaken ? "input-warning" : ""}`}
                  value={customerReference}
                  onChange={(e) => {
                    setCustomerReference(e.target.value);
                    setShowRefSuggestions(true);
                  }}
                  onFocus={() => setShowRefSuggestions(true)}
                  onBlur={() => setShowRefSuggestions(false)}
                  autoComplete="off"
                />
                {isRefTaken && (
                  <small className="ref-warning-text">
                    ⚠ This customer reference already exists in the database. Please use a different one.
                  </small>
                )}
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Delivery Method:</label>
                <input
                  type="text"
                  className="form-input"
                  value={deliveryMethod}
                  onChange={(e) => setDeliveryMethod(e.target.value)}
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Courier Service:</label>
                <div className="courier-wrapper">
                  {!isCourierManualMode ? (
                    <>
                      <div className="form-group" style={{ flex: 1, marginBottom: 0 }}>
                        <select
                          className="form-select"
                          value={courierService}
                          onChange={handleCourierChange}
                          required
                        >
                          <option value="">Select courier service</option>
                          {courierOptions.map((courier) => (
                            <option key={courier} value={courier}>
                              {courier}
                            </option>
                          ))}
                        </select>
                      </div>
                      <button
                        type="button"
                        className="courier-toggle-button"
                        onClick={toggleCourierMode}
                      >
                        <MdEdit /> Add Custom
                      </button>
                    </>
                  ) : (
                    <>
                      <div className="form-group" style={{ flex: 1, marginBottom: 0 }}>
                        <input
                          type="text"
                          className="form-input"
                          value={manualCourierService}
                          onChange={handleManualCourierChange}
                          onBlur={handleManualCourierBlur}
                          onKeyDown={handleManualCourierKeyDown}
                          placeholder="Enter courier service name..."
                          required
                        />
                        <small className="courier-manual-hint">
                          Enter any courier service name (Press Enter or click away to update note)
                        </small>
                      </div>
                      <button
                        type="button"
                        className="courier-toggle-button manual-mode"
                        onClick={toggleCourierMode}
                      >
                        📋 Select from list
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Agent Name:</label>
                <input
                  type="text"
                  className="form-input"
                  value={agentName}
                  onChange={(e) => setAgentName(e.target.value)}
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Agent Number:</label>
                <input
                  type="text"
                  className="form-input"
                  value={agentNumber}
                  onChange={(e) => setAgentNumber(e.target.value)}
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Note:</label>
                <textarea
                  ref={noteRef}
                  className="form-textarea"
                  value={note}
                  onChange={(e) => setNote(e.target.value)}
                  placeholder="Enter note here... (Courier selection will auto-fill this field)"
                  rows="3"
                />
                <small className="note-hint">
                  <FaLightbulb />Selecting a courier service will automatically add relevant details here. You can also edit or add more text.
                </small>
              </div>
            </div>
          </div>
          <button type="submit" className="submit-button" disabled={isLoading}>
            {isLoading ? "Placing Order..." : "Place Order"}
          </button>
        </form>
        {error && (
          <div style={{ color: 'red', marginTop: '10px' }}>
            Error: {error.data?.error || error.data?.message || "Failed to place order"}
          </div>
        )}
      </div>
    </div>
  );
};

export default PlaceOrders;